import type { RouterRootContext } from '@/router'
import { checkAuthRoleBeforeLoad } from '@/components/beforeLoad'
import { GlobalErrorPage } from '@/components/ui/errors'
import { defaultPaginationSchema } from '@/validators/pagination'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/users')({
  component: Outlet,
  errorComponent: GlobalErrorPage,
  validateSearch: defaultPaginationSchema,
  beforeLoad: ctx => checkAuthRoleBeforeLoad(ctx.context as RouterRootContext, 'admin'),
})
